<template>
    <v-app id="inspire">
        <section class="registration-form">
            <div class="container">
                <validation-observer
                    ref="form"
                    v-slot="{ invalid }"
                    :class="{ 'white-overlay': isProcessing }"
                >
                    <div class="row mb-5">
                        <div class="col-12">
                            <h2>Reserveringsformulier</h2>
                            <spinner v-if="loading" />

                            <p v-if="!availableDates.length && !loading">
                                Helaas, op dit moment zijn er geen reserveringen
                                voor deze activiteit mogelijk.
                            </p>
                            <p v-if="success" v-html="succesMessage"></p>
                        </div>
                    </div>
                    <form
                        v-show="!loading && !success && availableDates.length"
                        @submit.prevent="signup"
                    >
                        <div class="row mb-4">
                            <div class="col-12">
                                <p
                                    v-if="
                                        activity != null &&
                                            form.provider != null
                                    "
                                >
                                    Je schrijft je in voor de activiteit:
                                    <strong>{{ activity.title }}.</strong><br />
                                    Deze activiteit wordt aangeboden door:
                                    <strong>{{ activity.providerName }}</strong>
                                </p>
                                <p v-if="!user">
                                    Leerkracht of ICCer? Log eerst in met je
                                    account.
                                    <a :href="loginUrl" class="btn ml-2">
                                        <span>
                                            Login
                                            <i
                                                class="fa fa-arrow-right ml-2"
                                                aria-hidden="true"
                                            ></i>
                                        </span>
                                    </a>
                                </p>
                                <p v-if="error" class="input-error">
                                    {{ errorMessage }}
                                </p>
                            </div>
                        </div>
                        <template v-if="availableDates.length">
                            <div class="row mb-4">
                                <h3 class="col-12">
                                    Datum / tijd
                                </h3>
                            </div>
                            <template v-if="timeChoice === 1">
                                <div class="row mb-4">
                                    <v-col cols="12">
                                        <label class="mb-0"
                                            >Geef jouw voorkeur voor maand en
                                            weekdag op. De aanbieder neemt
                                            contact met je op voor een precieze
                                            datum.</label
                                        >
                                    </v-col>
                                </div>
                                <div class="row mb-4">
                                    <v-col cols="4">
                                        <dropdown-input
                                            ref="timeChoice"
                                            v-model="form.month"
                                            class="col-12"
                                            :options="availableMonths"
                                            name="Maand"
                                        >
                                        </dropdown-input>
                                    </v-col>

                                    <v-col cols="4">
                                        <dropdown-input
                                            ref="timeChoice"
                                            v-model="form.weekday"
                                            class="col-12"
                                            :options="occurenceDays"
                                            name="Weekdag"
                                        >
                                        </dropdown-input>
                                    </v-col>
                                </div>
                                <div class="row mb-4">
                                    <v-col cols="12">
                                        <textarea-input
                                            ref="timeChoiceComments"
                                            v-model="form.timeChoiceComments"
                                            class="col-8 mb-2"
                                            name="Heb je nog verdere opmerkingen over
                                            het gewenste moment?"
                                            placeholder="Geef hier aan wat jou goed uitkomt."
                                        />
                                    </v-col>
                                </div>
                            </template>
                            <template v-if="timeChoice === 2">
                                <div class="row mb-4">
                                    <v-col cols="12" sm="6" md="3">
                                        <label class="mb-0"
                                            >Kies de voorkeursdatum</label
                                        >
                                        <v-menu
                                            v-model="isPreferredDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="date"
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="date"
                                                locale="nl-nl"
                                                :allowed-dates="allowedDates"
                                                :max="dateInAYear"
                                                :min="todaysDate"
                                                @input="
                                                    (isPreferredDate = false),
                                                        clearTime()
                                                "
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <dropdown-input
                                        ref="selectedTime"
                                        v-model="form.scheduleId"
                                        class="col-12 col-sm-4 col-md-3"
                                        :options="availableTimes"
                                        name="Gewenste tijd"
                                    >
                                    </dropdown-input>
                                </div>
                            </template>
                        </template>

                        <div
                            v-show="
                                user == null || Object.keys(user).length === 0
                            "
                            class="col-12"
                        >
                            <h3>
                                Schrijf je jezelf in als een ouder of voor een
                                BSO?
                            </h3>
                        </div>
                        <dropdown-input
                            v-show="
                                user == null || Object.keys(user).length === 0
                            "
                            ref="signupType"
                            v-model="form.signupType"
                            class="col-6"
                            :options="signupTypes"
                            name="Type reserveerder"
                            rules="required"
                        />
                        <div v-if="showLoginMsg">
                            <div v-html="loginText"></div>
                            <div>
                                <a :href="loginUrl" class="btn ml-2">
                                    <span>
                                        Login
                                        <i
                                            class="fa fa-arrow-right ml-2"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="form.signupType !== 1" class="row mb-4">
                                <div class="col-12">
                                    <h3>{{ formName }}</h3>
                                </div>
                                <text-input
                                    ref="schoolName"
                                    v-model="form.schoolName"
                                    class="col-12 col-sm-6 mb-2"
                                    :name="formSchoolField"
                                    :readonly="disallowModifySchoolName"
                                />
                                <text-input
                                    v-if="form.signupType === 2"
                                    ref="brinNumber"
                                    v-model="form.brinNumber"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Brin nummer"
                                    rules="required"
                                    :readonly="disallowModifySchoolName"
                                />
                                <text-input
                                    v-if="form.signupType === 3"
                                    ref="LRKNumber"
                                    v-model="form.lrkNumber"
                                    class="col-12 col-sm-6 mb-2"
                                    name="LRK nummer"
                                    rules="required"
                                />
                                <text-input
                                    ref="postalCode"
                                    v-model="form.postalCode"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Postcode"
                                    :rules="{
                                        required: true,
                                        regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                                    }"
                                />
                                <text-input
                                    ref="address"
                                    v-model="form.address"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Straat en huisnummer"
                                    rules="required"
                                />
                                <text-input
                                    ref="city"
                                    v-model="form.city"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Plaats"
                                    rules="required"
                                />
                                <text-input
                                    ref="phone"
                                    v-model="form.phone"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Telefoon"
                                    rules="required|digits:10"
                                />
                            </div>
                            <div v-if="form.signupType !== 1" class="row mb-4">
                                <div class="col-12">
                                    <h3>
                                        Klas informatie
                                    </h3>
                                </div>
                                <div
                                    v-if="
                                        user != null &&
                                            Object.keys(user).length > 0 &&
                                            form.signupType === 2 &&
                                            user.groups !== null &&
                                            user.groups.length > 0
                                    "
                                    class="col-12 col-sm-6 mb-2"
                                >
                                    <dropdown-input
                                        ref="group"
                                        v-model="form.group"
                                        class="col-6"
                                        :options="user.groups"
                                        name="Groep"
                                        rules="required"
                                    />
                                </div>
                                <div v-else class="col-12 col-sm-6 mb-2">
                                    <text-input
                                        ref="group"
                                        v-model="form.group"
                                        name="Groep"
                                        rules="required"
                                    />
                                </div>
                                <div class="col-12 col-sm-6 mb-2">
                                    <text-input
                                        ref="studentAmount"
                                        v-model="form.studentAmount"
                                        name="Aantal leerlingen"
                                        rules="required"
                                        type="number"
                                    />
                                    <p
                                        v-if="groupIsTooLarge"
                                        class="input-error"
                                    >
                                        Helaas, er is plek voor maximaal
                                        {{ remainingPlaces }}
                                        leerlingen.
                                    </p>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-12">
                                    <h3 v-if="form.signupType === 1">
                                        Ouder / Verzorger
                                    </h3>
                                    <h3 v-else>Leerkracht / begeleider</h3>
                                </div>
                                <text-input
                                    ref="contactName"
                                    v-model="form.contactName"
                                    class="col-12 col-sm-4 mb-2"
                                    name="Naam"
                                    rules="required"
                                />
                                <text-input
                                    ref="contactEmail"
                                    v-model="form.contactEmail"
                                    class="col-12 col-sm-4 mb-2"
                                    name="E-mailadres"
                                    rules="required|email"
                                />
                                <text-input
                                    ref="contactPhone"
                                    v-model="form.contactPhone"
                                    class="col-12 col-sm-4 mb-2"
                                    name="Telefoonnummer"
                                    rules="required|digits:10"
                                />
                            </div>
                            <div
                                v-if="
                                    user != null &&
                                        Object.keys(user).length > 0 &&
                                        user.childrenData
                                "
                                class="row mb-8"
                            >
                                <div class="col-12">
                                    <h3>Kind</h3>
                                </div>
                                <dropdown-input
                                    ref="selectChild"
                                    v-model="selectedChild"
                                    class="col-6"
                                    :options="user.childrenData"
                                    name="Kind"
                                    rules="required"
                                />
                                <br />
                                <br />
                            </div>
                            <div v-else>
                                <div
                                    v-if="form.signupType === 1"
                                    class="row mb-2"
                                >
                                    <div class="col-12">
                                        <h3>Kind</h3>
                                    </div>
                                    <text-input
                                        ref="childFirstName"
                                        v-model="form.childFirstName"
                                        class="col-12 col-sm-4"
                                        name="Voornaam"
                                        rules="required"
                                        placeholder=""
                                    />
                                    <text-input
                                        ref="childLastName"
                                        v-model="form.childLastName"
                                        class="col-12 col-sm-4"
                                        name="Achternaam"
                                        rules="required"
                                        placeholder=""
                                    />
                                </div>
                                <div
                                    v-if="form.signupType === 1"
                                    class="row mb-4"
                                >
                                    <text-input
                                        ref="childSchool"
                                        v-model="form.childSchool"
                                        class="col-12 col-sm-4"
                                        name="School / BSO"
                                        rules="required"
                                        placeholder=""
                                    />
                                    <text-input
                                        ref="childGroup"
                                        v-model="form.childGroup"
                                        class="col-12 col-sm-4"
                                        name="Groep"
                                        rules="required"
                                        placeholder=""
                                    />
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div
                                    v-if="
                                        form.signupType == 2 &&
                                            form.discounts != null &&
                                            (form.discounts.subscriptions !=
                                                null ||
                                                form.discounts.budgets !=
                                                    null ||
                                                form.discounts.stripCards)
                                    "
                                    class="col-12"
                                >
                                    <h3>Kortingen</h3>
                                </div>
                                <checkbox-input
                                    v-if="
                                        form.signupType == 2 &&
                                            form.discounts != null &&
                                            form.discounts.subscriptions != null
                                    "
                                    v-model="
                                        form.discounts.subscriptions.activated
                                    "
                                    class="col-12 mb-2"
                                    name="Abbonement"
                                >
                                    <slot
                                        v-if="
                                            form.discounts.subscriptions.free ==
                                                false
                                        "
                                        >{{ form.discounts.subscriptions.name }}
                                        -
                                        {{
                                            form.discounts.subscriptions
                                                .discount
                                        }}
                                        % korting</slot
                                    >

                                    <slot
                                        v-if="
                                            form.discounts.subscriptions.free ==
                                                true
                                        "
                                        >{{
                                            form.discounts.subscriptions.name
                                        }}
                                        - Gratis</slot
                                    >
                                </checkbox-input>
                                <checkbox-input
                                    v-if="
                                        form.signupType == 2 &&
                                            form.discounts != null &&
                                            form.discounts.budgets != null
                                    "
                                    v-model="form.discounts.budgets.activated"
                                    class="col-12 mb-2"
                                    name="Budget"
                                >
                                    <slot
                                        >{{ form.discounts.budgets.name }} -
                                        &euro;
                                        {{
                                            form.discounts.budgets.amount
                                        }}</slot
                                    >
                                </checkbox-input>
                                <checkbox-input
                                    v-if="
                                        form.signupType == 2 &&
                                            form.discounts != null &&
                                            form.discounts.stripCards != null
                                    "
                                    v-model="
                                        form.discounts.stripCards.activated
                                    "
                                    class="col-12 mb-2"
                                    name="Strippenkaart"
                                >
                                    <slot
                                        >{{ form.discounts.stripCards.name }} -
                                        Aantal strippen:
                                        {{
                                            form.discounts.stripCards.amount
                                        }}</slot
                                    >
                                </checkbox-input>
                                <div class="col-12">
                                    <h3>Overig</h3>
                                </div>
                                <textarea-input
                                    ref="comments"
                                    v-model="form.comments"
                                    class="col-12 mb-2"
                                    name="Opmerkingen"
                                    placeholder="Geef hier bijzonderheden aan die belangrijk zijn voor de aanbieder"
                                />
                                <checkbox-input
                                    v-model="form.newsletterVerwonder"
                                    class="col-12 mb-2"
                                    name="Nieuwsbrief 'om de hoek'"
                                >
                                    <slot>Nieuwsbrief 'om de hoek' </slot>
                                </checkbox-input>
                                <checkbox-input
                                    v-model="form.newsletterProvider"
                                    class="col-12 mb-2"
                                    name="Nieuwsbrief van organisatie"
                                >
                                    <slot>Nieuwsbrief van organisatie </slot>
                                </checkbox-input>
                                <checkbox-input
                                    v-if="privacyLink"
                                    v-model="form.privacyAccepted"
                                    class="col-12 mb-2"
                                    name="U dient akkoord te gaan met de algemene voorwaarden"
                                    rules="required"
                                >
                                    <slot>
                                        Ik ga akkoord met de
                                        <a
                                            :href="privacyLink.url"
                                            target="_blank"
                                            class="ml-1 color--blue-7"
                                        >
                                            algemene voorwaarden
                                        </a>
                                    </slot>
                                </checkbox-input>
                            </div>
                            <div class="row mb-4">
                                <button
                                    v-if="!loading && !isProcessing"
                                    type="submit"
                                    class="btn mr-4 h-100"
                                    :class="{
                                        'btn btn--gray-4 disabled':
                                            submitButtonIsDisabled || invalid
                                    }"
                                    :disabled="
                                        submitButtonIsDisabled || invalid
                                    "
                                >
                                    <span>Meld je aan!</span>
                                </button>
                                <spinner v-if="loading || isProcessing" />
                            </div>

                            <div
                                v-if="accountExists"
                                class="fixed-top d-flex justify-content-center message--login"
                            >
                                <div class="w-75 mt-4 mb-2">
                                    <h3>
                                        Het opgegeven account bestaat al. Log nu
                                        in om je aan te melden
                                        <a :href="loginUrl" class="btn ml-2">
                                            <span>
                                                Login
                                                <i
                                                    class="fa fa-arrow-right ml-2"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </section>
    </v-app>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import checkboxInput from '@/components/form/checkbox-input';
import textareaInput from '@/components/form/textarea-input';
import dropdownInput from '@/components/form/dropdown-input';
import spinner from '@/components/spinner';
import Axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, { siteKey: '6Le0nPkbAAAAAObFIEw575-1G4shRCyKg3zhUdjM' });

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        checkboxInput,
        textareaInput,
        dropdownInput,
        spinner
    },
    props: {
        privacyLink: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            selectedChild: '',
            form: {
                signupType: 1,
                brinNumber: '',
                lrkNumber: '',
                schoolName: '',
                postalCode: '',
                address: '',
                city: '',
                phone: '',
                group: '',
                studentAmount: '',
                contactName: '',
                contactEmail: '',
                contactPhone: '',
                childFirstName: '',
                childLastName: '',
                childSchool: '',
                childGroup: '',
                comments: '',
                newsletterVerwonder: false,
                newsletterProvider: false,
                activityId: '',
                providerId: '',
                scheduleId: 0,
                privacyAccepted: false,
                discounts: {},
                provider: {},
                weekday: 1,
                month: 1,
                timeChoiceComments: ''
            },
            errorMessage:
                'Controleer jouw invoer, mogelijk zijn er verplichte velden niet ingevuld of zijn er velden niet correct ingevuld.',
            succesMessage:
                'Bedankt je hebt je zojuist ingeschreven. Je ontvangt zo snel mogelijk bericht van de aanbieder van deze activiteit.',
            success: false,
            url: '/api/registration/addregistration',
            signupTypes: [],
            activity: {},
            error: false,
            loading: true,
            isProcessing: false,
            bookingLink: '',
            noAccountMessage: '',
            date: '',
            pickedDate: {},
            isPreferredDate: false,
            availableDates: [],
            availableTimes: [],
            availableMonths: [],
            occurenceDays: [],
            timeChoice: 1,
            accountExists: false,
            loginUrl: '',
            loginText: '',
            groupIsTooLarge: false,
            currentBookings: 0
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        remainingPlaces() {
            const places =
                parseInt(this.activity.maxGroupSize) - this.currentBookings;
            return places <= 0 ? 0 : places;
        },
        submitButtonIsDisabled() {
            return (
                this.loading ||
                this.groupIsTooLarge ||
                this.error ||
                this.isProcessing ||
                this.accountExists
            );
        },
        disallowModifySchoolName() {
            return (
                this.user &&
                (this.user.contentTypeAlias === 'teacher' ||
                    this.user.contentTypeAlias === 'school')
            );
        },
        showLoginMsg() {
            return (
                !this.user &&
                (this.form.signupType === 2 || this.form.signupType === 4)
            );
        },
        formName() {
            switch (this.form.signupType) {
                case 3:
                    return 'BSO';
                default:
                    return 'School / BSO';
            }
        },
        formSchoolField() {
            switch (this.form.signupType) {
                case 3:
                    return 'Naam BSO';
                default:
                    return 'Schoolnaam';
            }
        },
        todaysDate() {
            const date = new Date();
            return date.toISOString();
        },
        dateInAYear() {
            const todaysDate = new Date();
            todaysDate.setFullYear(todaysDate.getFullYear() + 1);
            return todaysDate.toISOString();
        }
    },
    watch: {
        'form.scheduleId': function() {
            this.setCurrentBookingsAvailability();
        },
        'form.studentAmount': function() {
            if (this.activity.maxGroupSize === 0) {
                return;
            }
            this.groupIsTooLarge =
                parseInt(this.form.studentAmount) + this.currentBookings >
                this.activity.maxGroupSize;
        },
        'form.contactEmail': function() {
            if (this.form.contactEmail !== '') {
                this.checkEmail();
            }
        },
        selectedChild: function(val) {
            this.form.childFirstName = val.childFirstname;
            this.form.childInsertion = val.childInsertion;
            this.form.childLastName = val.childLastname;
            this.form.childSchool = val.childSchool;
            this.form.childGroup = val.childGroup;
        },
        user: function(user) {
            if (user != null) {
                switch (user.contentTypeAlias) {
                    case 'parent':
                        this.$refs.signupType.currentValue = 1;
                        this.form.signupType = 1;
                        break;
                    case 'school':
                        this.$refs.signupType.currentValue = 2;
                        this.form.signupType = 2;
                        this.form.brinNumber = user.brin;
                        break;
                    case 'bso':
                        this.$refs.signupType.currentValue = 3;
                        this.form.signupType = 3;
                        this.form.lrkNumber = user.lrk;
                        break;
                    case 'teacher':
                        this.$refs.signupType.currentValue = 4;
                        this.form.signupType = 4;
                        this.form.brinNumber = user.school.brin;
                        this.form.schoolName = user.school.name;
                        this.form.postalCode = user.school.zipcode;
                        this.form.address = (
                            user.school.street +
                            ' ' +
                            user.school.housenumber
                        ).trim();
                        if (
                            user.school.housenumberAddition != null &&
                            user.school.housenumberAddition != '' &&
                            user.school.housenumberAddition != 'null'
                        ) {
                            this.form.address +=
                                ' ' + user.school.housenumberAddition.trim();
                        }
                        this.form.city = user.school.city;
                        this.form.phone = user.school.phone;
                        this.form.childGroup = user.group;
                        this.form.contactName = user.fullName;
                        this.form.contactEmail = user.userName;
                        this.form.contactPhone = user.school.phone;
                        this.form.group =
                            user.groups != null &&
                            user.groups.length > 0 &&
                            user.groups[0] != null
                                ? user.groups[0].name
                                : '';
                        break;
                }
            }

            if (user != null && user.contentTypeAlias !== 'teacher') {
                this.form.schoolName = user.name;
                this.form.postalCode = user.zipcode;
                this.form.address = (
                    user.street +
                    ' ' +
                    user.housenumber
                ).trim();
                if (
                    user.housenumberAddition != null &&
                    user.housenumberAddition != '' &&
                    user.housenumberAddition != 'null'
                ) {
                    this.form.address += ' ' + user.housenumberAddition.trim();
                }
                this.form.city = user.city;
                this.form.phone = user.phone;
                this.form.contactName = user.contactPersonFullName;
                this.form.contactEmail = user.userName;
                this.form.contactPhone = user.contactPersonPhone;
            }
        }
    },
    created() {
        this.getSignupTypes();
        this.getBookingLink();
        this.getNoAccountMessage();
        this.getLoginText();
        this.getLoginUrl();

        if (this.$route.query.activityId) {
            this.form.activityId = this.$route.query.activityId;
            this.activity = this.getActivity();
        }

        if (this.$route.query.providerId) {
            this.form.providerId = this.$route.query.providerId;
        }
    },
    methods: {
        allowedDates(val) {
            if (this.availableDates != null) {
                for (let i = 0; i < this.availableDates.length; i++) {
                    if (this.availableDates[i] == val) {
                        return val;
                    }
                }
            }
        },
        getAvailableDate() {
            this.availableDates = [];
            for (let i = 0; i < this.activity.schedule.length; i++) {
                const dateName = this.activity.schedule[i].dateName;
                if (!this.availableDates.includes(dateName)) {
                    this.availableDates.push(dateName);
                }
            }
        },
        getAvailableMonths() {
            this.availableMonths = [];

            let beginDate = new Date(this.activity.beginDate);
            //Bijv. als het nu september is, willen we geen opties van afgelopen maart tonen
            if (beginDate < new Date()) {
                beginDate = new Date();
            }

            const endDate = new Date(this.activity.endDate);

            const beginMonth = beginDate.getMonth();
            const endMonth = endDate.getMonth();

            const availableMonthIndices = [];

            if (
                endDate.getFullYear() > beginDate.getFullYear() ||
                (endDate.getFullYear() === beginDate.getFullYear() &&
                    endDate.getMonth() >= beginDate.getMonth())
            ) {
                // Indien de range over meerdere jaren loopt, tellen we door na december (januari wordt dan maand 13)
                let rangeEnd =
                    endMonth +
                    (endDate.getFullYear() - beginDate.getFullYear()) * 12;
                rangeEnd = Math.min(rangeEnd, beginMonth + 11); // Grens bij 12 maanden vanaf begin
                for (let i = beginMonth; i <= rangeEnd; i++) {
                    //Modulo 12 om indices weer terug te krijgen naar 0-12 range
                    availableMonthIndices.push(i % 12);
                }
            } else {
                for (let i = beginMonth; i <= endMonth; i++) {
                    availableMonthIndices.push(i);
                }
            }

            availableMonthIndices.forEach(i => {
                const month = this.activity.occurenceMonths[i];
                const monthCapitalized =
                    month.name[0].toUpperCase() + month.name.slice(1);
                this.availableMonths.push({
                    id: i + 1,
                    name: monthCapitalized
                });
            });

            this.form.month = this.availableMonths[0].id;
        },
        getAvailableWeekdays() {
            this.occurenceDays = [];
            this.activity.occurenceDays.forEach(day => {
                const dayCapitalized =
                    day.name[0].toUpperCase() + day.name.slice(1);
                this.occurenceDays.push({
                    id: day.id,
                    name: dayCapitalized
                });
            });

            this.form.weekday = this.occurenceDays[0].id;
        },
        clearTime() {
            this.getAvailableDate();
            this.availableTimes = [];
            this.$nextTick(() => {
                if (this.availableTimes != null) {
                    this.form.scheduleId = this.availableTimes[0].id;
                }
                if (this.$refs.selectedTime != undefined) {
                    this.$refs.selectedTime.value = this.form.scheduleId;
                    this.$refs.selectedTime.currentValue = this.form.scheduleId;
                }
            });
            if (this.$refs.selectedTime != undefined) {
                this.$refs.selectedTime.value = this.form.scheduleId;
                this.$refs.selectedTime.currentValue = this.form.scheduleId;
            }
            for (const schedule in this.activity.schedule) {
                if (
                    this.activity.schedule != null &&
                    this.activity.schedule[schedule].dateName === this.date &&
                    this.activity.schedule[schedule].times != null
                ) {
                    this.availableTimes.push(this.activity.schedule[schedule].times[0]);

                    if (this.$refs.selectedTime != undefined) {
                        this.$refs.selectedTime.value = this.activity.schedule[schedule].id;
                        this.$refs.selectedTime.currentValue = this.activity.schedule[schedule].id;
                        this.$refs.selectedTime.value = 0;
                        this.$refs.selectedTime.currentValue = 0;
                    }
                }
            }
            this.availableTimes = _.orderBy(this.availableTimes, 'startTime');
        },
        getLoginUrl() {
            Axios.get('/api/registration/loginformurl')
                .then(response => {
                    this.loginUrl =
                        response.data +
                        '?activityId=' +
                        this.form.activityId +
                        '&providerId=' +
                        this.form.providerId;
                })
                .catch(() => false);
        },
        setCurrentBookingsAvailability() {
            this.loading = true;
            Axios.get('/w3subookings/activity/GetCurrentBookingsForSchedule', {
                params: {
                    scheduleId: this.form.scheduleId
                }
            })
                .then(response => {
                    this.currentBookings = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getActivity() {
            this.loading = true;
            Axios.get('/w3subookings/activity/get', {
                params: {
                    activityId: this.form.activityId
                }
            }).then(response => {
                this.activity = response.data;
                this.timeChoice = response.data.timeChoice[0].id;
                this.getAvailableDate();
                this.getAvailableMonths();
                this.getAvailableWeekdays();
                this.availableTimes = [];
                if (this.user === null) {
                    this.setDates();
                    this.loading = false;
                } else {
                    this.getDiscounts().then(response => {
                        this.form.discounts = response.data;
                        this.setDates();
                        this.loading = false;
                    });
                }
            });
        },
        setDates() {
            if (this.date == '') {
                this.date = this.availableDates[0];
            }
            this.$nextTick(() => {
                if (
                    this.form.scheduleId == 0 &&
                    this.availableTimes[0] != null
                ) {
                    this.form.scheduleId = this.availableTimes[0].id;
                }
                if (this.form.scheduleId && this.$refs.selectedTime != undefined) {
                    this.$refs.selectedTime.value = this.form.scheduleId;
                    this.$refs.selectedTime.currentValue = this.form.scheduleId;
                }
            });

            for (const schedule in this.activity.schedule) {
                if (this.activity.schedule[schedule].dateName === this.date) {
                    this.availableTimes.push(
                        this.activity.schedule[schedule].times[0]
                    );

                    if (this.$refs.selectedTime != undefined) {
                        this.$refs.selectedTime.value = this.activity.schedule[schedule].id;
                        this.$refs.selectedTime.currentValue = this.activity.schedule[schedule].id;
                    }
                }
            }

            this.availableTimes.sort(function(a, b) {
                return (
                    Date.parse(
                        '1970/01/01 ' +
                            a.startTime.slice(0, -2) +
                            ' ' +
                            a.startTime.slice(-2)
                    ) -
                    Date.parse(
                        '1970/01/01 ' +
                            b.startTime.slice(0, -2) +
                            ' ' +
                            b.startTime.slice(-2)
                    )
                );
            });
        },
        getDiscounts() {
            if (this.user === null) {
                return;
            }
            return Axios({
                method: 'post',
                url: '/api/registration/getdiscounts',
                data: {
                    activityId: this.form.activityId,
                    schoolBrin: this.user.brin,
                    schoolName: this.user.name,
                    providerId: this.form.providerId
                }
            });
        },
        checkEmail() {
            if (this.form.contactEmail != '') {
                Axios.get('/w3subookings/member/loggedin', {}).then(
                    response => {
                        if (response.data == false) {
                            Axios.get('/w3subookings/member/exists', {
                                params: {
                                    email: this.form.contactEmail
                                }
                            }).then(response => {
                                this.accountExists = response.data;
                                this.loading = false;
                            });
                        }
                    }
                );
            }
        },
        signup(e) {
            e.preventDefault();
            this.isProcessing = true;
            this.errorMessage = '';
            this.$refs.form.validate().then(success => {
                if (this.date == '') {
                    this.errorMessage =
                        'Er is geen datum gekozen of er zijn geen beschikbare datums meer over voor deze activiteit';
                    this.error = true;
                    window.scrollTo(0, 0);
                    this.isProcessing = false;
                    return;
                }
                if (this.form.scheduleId == '' || this.form.scheduleId === 0) {
                    this.errorMessage =
                        'Er is geen tijd gekozen of er zijn geen beschikbare tijden meer over voor deze activiteit';
                    this.error = true;
                    window.scrollTo(0, 0);
                    this.isProcessing = false;
                    return;
                }

                this.isProcessing = true;
                if (success) {
                    if (
                        this.user != null &&
                        this.user.groups != null &&
                        this.user.memberTypeAlias == 'school' &&
                        this.user.groups.length == 0
                    ) {
                        this.user.groups.push({
                            id: this.form.group,
                            name: this.form.group,
                            removed: false,
                            takeObjectInSelect: false
                        });

                        Axios.post('/clientdashboard/school/update', {
                            profile: this.user
                        }).catch(() => {
                            this.errorMessage =
                                'Er is iets mis gegaan met het updaten van uw gegevens. Excuses voor het ongemak';
                            this.error = true;
                            window.scrollTo(0, 0);
                            this.isProcessing = false;
                        });
                    }
                    Axios({
                        method: 'post',
                        url: this.url,
                        data: this.form
                    })
                        .then(() => {
                            if (
                                this.user == null ||
                                typeof this.user.contentTypeAlias ===
                                    'undefined'
                            ) {
                                this.succesMessage = this.noAccountMessage;
                                this.success = true;
                                this.isProcessing = false;
                                window.scrollTo(0, 0);
                            } else {
                                this.isProcessing = true;
                                window.location.href = this.bookingLink;
                            }
                        })
                        .catch(error => {
                            if (error.response.data.ExceptionMessage) {
                                this.errorMessage =
                                    'Er is iets mis gegaan met het reserveren. Excuses voor het ongemak. De foutmelding is: ' +
                                    error.response.data.ExceptionMessage;
                            } else {
                                this.errorMessage =
                                    'Er is iets mis gegaan met het reserveren. Excuses voor het ongemak.';
                            }
                            this.error = true;
                            window.scrollTo(0, 0);
                            this.isProcessing = false;
                        });
                } else {
                    window.scrollTo(0, 0);
                    this.isProcessing = false;
                }
            });
        },
        getSignupTypes() {
            Axios.get('/api/registration/getsignuptypes').then(response => {
                this.signupTypes = response.data;
            });
        },
        getBookingLink() {
            Axios.get('/api/registration/getbookinglink').then(response => {
                this.bookingLink = response.data;
            });
        },
        getNoAccountMessage() {
            Axios.get('/api/registration/getnoaccountmessage').then(
                response => {
                    this.noAccountMessage = response.data;
                }
            );
        },
        getLoginText() {
            Axios.get('/api/registration/getlogintext').then(response => {
                this.loginText = response.data;
            });
        }
    }
};
</script>

<style lang="scss">
.message--login {
    border-bottom: 1px solid #cdcdcd;
    background-color: rgba(#fff, 0.85);
}
.v-application .v-picker__title.primary {
    background-color: $blue-7 !important;
}
.v-date-picker-table--date {
    .theme--light.v-btn.v-btn--disabled {
        color: #afafaf !important;
    }
}

.fa-chevron-right,
.fa-chevron-left {
    &:before,
    &:after {
        font-size: 0.825rem;
    }
}
.v-application .registration-form .primary--text {
    color: $blue-7 !important;
    caret-color: $blue-7 !important;
}

.input-error {
    color: $red;
}

.disabled {
    pointer-events: none;
}
.v-btn {
    &.v-date-picker-table__current {
        border-width: 2px;
    }
}

.white-overlay {
    display: block;
    &::after {
        position: absolute;
        content: ' ';
        background-color: rgba(#fff, 0.85);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
    }
}

.lds-ellipsis {
    z-index: 10;
}
</style>
